// Module
var code = `<style></style> <select id="tc-pump-select"></select>`;
// Exports
export default code;